module.exports = __webpack_public_path__ + "static/media/speedometer.46816bf2.svg";